module.exports = __webpack_public_path__ + "img/3.5e122dd0.jpg";